(function (root, factory) {
  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (root) root.ConsoleModderCompatibility = api;
  if (root && root.document) {
    var mount = function () {
      root.document.querySelectorAll("[data-compatibility-root]").forEach(api.init);
    };
    if (root.document.readyState === "loading") {
      root.document.addEventListener("DOMContentLoaded", mount, { once: true });
    } else {
      mount();
    }
    root.document.addEventListener("shopify:section:load", mount);
  }
})(typeof window !== "undefined" ? window : globalThis, function () {
  "use strict";

  var phatBoards = ["falcon", "jasper", "tonasket", "xenon", "zephyr"];
  var slimSBoards = ["trinity", "corona-slim"];
  var slimEBoards = ["corona-e", "winchester", "other-e"];
  var boardLabels = {
    trinity: "Trinity Slim",
    "corona-slim": "Corona / Waitsburg Slim family",
    falcon: "Falcon phat",
    jasper: "Jasper phat",
    tonasket: "Tonasket phat",
    xenon: "Xenon phat",
    zephyr: "Zephyr phat",
    "corona-e": "Corona-family Xbox 360 E",
    winchester: "Winchester (Barracuda) Xbox 360 E",
    "other-e": "another Xbox 360 E revision"
  };
  var modelLabels = {
    phat: "Original Xbox 360 (phat)",
    "slim-s": "Xbox 360 S (Slim)",
    "slim-e": "Xbox 360 E",
    unknown: "Not sure"
  };
  var routeLabels = {
    visual: "Visual identification",
    serial: "Serial provided (not decoded)",
    "manufacture-date": "Manufacture date"
  };

  function matchesModel(model, board) {
    if (model === "phat") return phatBoards.indexOf(board) !== -1;
    if (model === "slim-s") return slimSBoards.indexOf(board) !== -1;
    if (model === "slim-e") return slimEBoards.indexOf(board) !== -1;
    return false;
  }

  function uncertain(input, explanation, serviceStatus) {
    var isE = input.consoleModel === "slim-e";
    return {
      technicalStatus: "needs_verification",
      serviceStatus: isE ? "manual_review" : (serviceStatus || "needs_verification"),
      boardFamily: null,
      confidence: isE ? "manual_review" : "insufficient",
      headline: isE ? "Xbox 360 E — manual review required" : "We need a little more evidence",
      explanation: explanation,
      warning: isE
        ? "ConsoleModder does not automatically approve Xbox 360 E consoles. Ask for manual verification before ordering."
        : "Identification is uncertain. Do not rely on this result to order; ask ConsoleModder to verify the console first."
    };
  }

  function verifiedSlimLabelOutcome(input) {
    if (input.consoleModel !== "slim-s" || input.repairHistory !== "none") return null;
    if (input.labelAmps === "10.83A") {
      return {
        technicalStatus: "compatible",
        serviceStatus: "eligible",
        boardFamily: "Trinity Slim",
        confidence: "verified_label",
        headline: "Your Slim S label matches the Trinity family",
        explanation: "ConsoleMods’ identification guide lists 10.83A on the Xbox 360 S label as Trinity. With no known repair or board-swap history, this is a send-in service candidate, subject to confirmation of the installed board.",
        warning: "This is an exterior-label match, not inspection of the installed board. A replacement case, label or motherboard can invalidate it. Manufacturing dates and power-supply ratings do not increase this confidence."
      };
    }
    if (input.labelAmps === "9.6A") {
      return {
        technicalStatus: "compatible",
        serviceStatus: "eligible",
        boardFamily: "Corona / Waitsburg Slim family",
        confidence: "verified_label",
        headline: "Your Slim S label matches the Corona family",
        explanation: "ConsoleMods’ identification guide lists 9.6A on the Xbox 360 S label as the Corona / Waitsburg family. With no known repair or board-swap history, this is a send-in service candidate, subject to confirmation of the installed board.",
        warning: "This is a family-label match, not an inspection of the installed motherboard or the exact Corona revision/NAND type. A replacement case, label or motherboard can invalidate it. Manufacturing dates and power-supply ratings do not increase this confidence."
      };
    }
    return null;
  }

  function conflictingEvidence(input, now) {
    if (input.manufacturingDate) {
      var currentMonth = now.toISOString().slice(0, 7);
      if (input.manufacturingDate > currentMonth) {
        return "The manufacture date is in the future. Check whether it was read correctly; the portal cannot use it as board evidence.";
      }
      var firstModelYear = { phat: 2005, "slim-s": 2010, "slim-e": 2013, unknown: 2005 }[input.consoleModel];
      if (Number(input.manufacturingDate.slice(0, 4)) < firstModelYear) {
        return "The date predates the documented era of the selected console exterior. It may be a misread or service label, or a replacement case. Request manual verification; dates never confirm a board.";
      }
    }

    var phatAmps = ["16.5A", "14.2A", "12.1A"];
    var slimAmps = ["10.83A", "9.6A"];
    if ((input.consoleModel === "phat" && slimAmps.indexOf(input.labelAmps) !== -1)
      || (input.consoleModel === "slim-s" && phatAmps.indexOf(input.labelAmps) !== -1)
      || (input.consoleModel === "slim-e" && (phatAmps.indexOf(input.labelAmps) !== -1 || input.labelAmps === "10.83A"))) {
      return "The console-label amperage conflicts with the selected exterior. Check that this is the console label, not the power brick. Do not infer an installed motherboard from conflicting clues.";
    }
    var phatBoardAmps = { xenon: "16.5A", zephyr: "16.5A", falcon: "14.2A", jasper: "12.1A", tonasket: "12.1A" };
    if (input.consoleModel === "phat" && phatAmps.indexOf(input.labelAmps) !== -1
      && phatBoardAmps[input.boardRevision] && phatBoardAmps[input.boardRevision] !== input.labelAmps) {
      return "The selected phat board and console-label rating do not agree with the documented family indicators. A swapped case or repaired console needs manual verification, not an automatic board diagnosis.";
    }
    return null;
  }

  function assess(input, now) {
    now = now || new Date();
    var conflict = conflictingEvidence(input, now);
    if (conflict) return uncertain(input, conflict, input.consoleModel === "phat" ? "manual_review" : "needs_verification");
    if (input.repairHistory !== "none") {
      return uncertain(
        input,
        "A repair, refurbishment or unknown service history can mean the motherboard no longer matches the outside label. Please request a manual check.",
        input.consoleModel === "phat" ? "manual_review" : "needs_verification"
      );
    }

    var verifiedLabel = verifiedSlimLabelOutcome(input);
    if (input.boardRevision !== "none") {
      if (!matchesModel(input.consoleModel, input.boardRevision)) {
        return uncertain(input, "The selected motherboard revision does not match the console model you selected. The portal cannot confirm which board is installed.");
      }
      if (verifiedLabel) {
        var labelRevision = input.labelAmps === "10.83A" ? "trinity" : "corona-slim";
        if (input.boardRevision === labelRevision) return verifiedLabel;
        return uncertain(input, "The selected board name conflicts with the documented Slim S rear-label clue. Please request manual verification before ordering.");
      }
      var family = boardLabels[input.boardRevision] || null;
      if (input.boardRevision === "xenon" || input.boardRevision === "zephyr" || input.boardRevision === "winchester") {
        return {
          technicalStatus: "incompatible",
          serviceStatus: "not_eligible",
          boardFamily: family,
          confidence: "insufficient",
          headline: "Do not order based on this board selection",
          explanation: "If the selected " + family + " identification is correct, it is not compatible with RGH3" + (input.boardRevision === "winchester" ? " or JTAG" : "") + ". This checker cannot verify a customer-selected board revision.",
          warning: "Do not continue to order. Contact ConsoleModder to verify the board identification."
        };
      }
      if (input.boardRevision === "falcon" || input.boardRevision === "jasper" || input.boardRevision === "tonasket") {
        return {
          technicalStatus: "compatible",
          serviceStatus: "manual_review",
          boardFamily: family,
          confidence: "manual_review",
          headline: "Technically compatible, but the shop needs to review it",
          explanation: family + " can technically support RGH3, but phat-console boot behaviour can be inconsistent. ConsoleModder requires manual review.",
          warning: "This is not an automatic service approval. Contact the workshop before ordering."
        };
      }
      if (input.boardRevision === "corona-e" || input.boardRevision === "other-e") {
        return {
          technicalStatus: input.boardRevision === "corona-e" ? "compatible" : "needs_verification",
          serviceStatus: "manual_review",
          boardFamily: family,
          confidence: "manual_review",
          headline: "Xbox 360 E — manual review required",
          explanation: input.boardRevision === "corona-e"
            ? "A confirmed Corona-family Xbox 360 E can be technically compatible, but ConsoleModder reviews every E model individually."
            : "This E revision needs individual technical and service review.",
          warning: "Do not continue to order until ConsoleModder has confirmed suitability."
        };
      }
      return uncertain(input, "The selected Slim board revision is not independently verified. Use the documented rear-label check or request manual verification.");
    }
    if (verifiedLabel) return verifiedLabel;
    if (input.consoleModel === "slim-s") {
      return uncertain(input, "For an Xbox 360 S, the rear-label amperage is a useful clue. This label does not match the verified Trinity or Corona-family indicators used for automatic eligibility.");
    }
    if (input.consoleModel === "phat") {
      return uncertain(
        input,
        "A phat shape, serial, date or power rating alone does not confirm the motherboard. Falcon, Jasper and Tonasket can support RGH3 but need ConsoleModder review; confirmed Xenon and Zephyr are incompatible.",
        "manual_review"
      );
    }
    if (input.consoleModel === "slim-e") {
      return uncertain(input, input.labelAmps !== "unknown"
        ? "The Xbox 360 E case and power label do not confirm Corona versus Winchester. An E model always needs manual review."
        : "The Xbox 360 E case shape, serial and manufacture date cannot reliably distinguish Corona from Winchester. Please request manual verification.");
    }
    return uncertain(input, input.identificationRoute === "serial" || input.identificationRoute === "manufacture-date"
      ? "A serial number or manufacture date by itself cannot reliably confirm the motherboard revision. The serial is not sent to this service."
      : "The console shape and available label details are not enough to confirm the installed motherboard. Please request a manual check.");
  }

  function read(root) {
    function field(name) { return root.querySelector('[data-field="' + name + '"]'); }
    var selectedModel = root.querySelector('[data-field="consoleModel"]:checked');
    var serial = field("serial");
    return {
      consoleModel: selectedModel ? selectedModel.value : "unknown",
      identificationRoute: field("identificationRoute").value,
      serialProvided: !!(serial && serial.value.trim()),
      manufacturingDate: field("manufacturingDate").value || null,
      labelAmps: field("consoleLabelConfirmed").checked ? field("labelAmps").value : "unknown",
      repairHistory: field("repairHistory").value,
      boardRevision: field("boardRevision").value
    };
  }

  function setStep(root, next) {
    var panels = root.querySelectorAll("[data-step-panel]");
    var progress = root.querySelectorAll("[data-progress]");
    var stepCount = root.querySelector("[data-step-count]");
    panels.forEach(function (panel, index) { panel.hidden = index !== next; });
    progress.forEach(function (item, index) {
      if (index === next) item.setAttribute("aria-current", "step");
      else item.removeAttribute("aria-current");
      item.classList.toggle("is-complete", index < next);
    });
    stepCount.textContent = "Step " + (next + 1) + " of 3";
    var heading = panels[next].querySelector("[data-step-heading]");
    if (heading) heading.focus();
  }

  function returnToAnswers(form, resultContainer, onReturn) {
    resultContainer.hidden = true;
    resultContainer.innerHTML = "";
    form.hidden = false;
    onReturn();
  }

  function renderSummary(root) {
    var value = read(root);
    var summary = root.querySelector("[data-summary]");
    var revision = boardLabels[value.boardRevision] || "Not identified";
    var amps = value.labelAmps === "unknown" ? "Not confirmed from the console label" : value.labelAmps;
    var entries = [
      ["Console", modelLabels[value.consoleModel] || "Not sure"],
      ["Identification route", routeLabels[value.identificationRoute] || "Visual identification"],
      ["Serial", value.serialProvided ? "Provided locally; not decoded or sent" : "Not provided"],
      ["Rear label", amps],
      ["Board selection", revision],
      ["Repair history", value.repairHistory === "none" ? "No known repair" : value.repairHistory === "unknown" ? "Not sure" : "Repair, refurbishment or possible board swap"]
    ];
    summary.innerHTML = entries.map(function (entry) {
      return "<div><dt>" + escapeHtml(entry[0]) + "</dt><dd>" + escapeHtml(entry[1]) + "</dd></div>";
    }).join("");
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (char) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char];
    });
  }

  function renderResult(root, result) {
    var output = root.querySelector("[data-compatibility-result]");
    var family = result.boardFamily ? "<p class=\"cm-result__family\">Board family clue: <strong>" + escapeHtml(result.boardFamily) + "</strong></p>" : "";
    var technicalLabel = result.technicalStatus === "compatible" ? "Compatible in technical terms"
      : result.technicalStatus === "incompatible" ? "Incompatible if this board identification is correct"
      : "Not confirmed";
    var serviceLabel = result.serviceStatus === "eligible" ? "Potential candidate; subject to physical verification"
      : result.serviceStatus === "manual_review" ? "Manual review required"
      : result.serviceStatus === "not_eligible" ? "Do not proceed on this identification"
      : "Verification required";
    var confidenceLabel = result.confidence === "verified_label" ? "Documented Slim S label-family match; board not inspected"
      : result.confidence === "manual_review" ? "Manual review; not an automatic assessment"
      : "Insufficient evidence to confirm the board";
    var contact = root.getAttribute("data-contact-url") || "https://consolemodder.com/pages/contact-us";
    var serviceUrl = root.getAttribute("data-service-url");
    var className = result.technicalStatus === "incompatible" ? "cm-result--danger"
      : result.serviceStatus === "eligible" ? "cm-result--candidate" : "cm-result--review";
    var badge = result.technicalStatus === "incompatible" ? "Technically incompatible"
      : result.serviceStatus === "eligible" ? "Potential service candidate — verify at intake"
      : result.serviceStatus === "manual_review" ? "Manual review required" : "More verification needed";
    var optionalService = result.serviceStatus === "eligible" && serviceUrl
      ? "<a class=\"cm-button cm-button--primary\" href=\"" + escapeHtml(serviceUrl) + "\">View verified service details</a>"
      : "";
    output.className = "cm-compat__result " + className;
    output.innerHTML =
      "<p class=\"cm-result__badge\">" + escapeHtml(badge) + "</p>" +
      "<h2 tabindex=\"-1\" data-result-heading>" + escapeHtml(result.headline) + "</h2>" +
      "<dl class=\"cm-result__status-grid\">" +
      "<div><dt>Technical RGH3 status</dt><dd>" + escapeHtml(technicalLabel) + "</dd></div>" +
      "<div><dt>ConsoleModder service</dt><dd>" + escapeHtml(serviceLabel) + "</dd></div>" +
      "<div><dt>Evidence confidence</dt><dd>" + escapeHtml(confidenceLabel) + "</dd></div></dl>" +
      family +
      "<p>" + escapeHtml(result.explanation) + "</p>" +
      "<p class=\"cm-result__warning\">" + escapeHtml(result.warning) + "</p>" +
      "<p class=\"cm-result__disclosure\">This theme provides guidance only. It does not verify the board, reserve stock, approve a service or enforce Shopify checkout.</p>" +
      (result.serviceStatus !== "eligible" ? "<a class=\"cm-button cm-button--quiet\" href=\"" + escapeHtml(contact) + "\">Ask for manual verification</a>" : optionalService) +
      "<button class=\"cm-button cm-button--quiet cm-review-button\" type=\"button\" data-review-answers>Review your answers</button>";
    output.hidden = false;
    var heading = output.querySelector("[data-result-heading]");
    if (heading) heading.focus();
    root.querySelector("[data-compatibility-form]").hidden = true;
    root.querySelector("[data-result]").setAttribute("aria-label", "Compatibility assessment result");
  }

  function init(root) {
    if (!root || root.dataset.compatibilityReady === "true") return;
    var form = root.querySelector("[data-compatibility-form]");
    if (!form) return;
    root.dataset.compatibilityReady = "true";
    var step = 0;
    var resultContainer = root.querySelector("[data-result]");

    function updateRoute() {
      var route = form.querySelector('[data-field="identificationRoute"]').value;
      var serialField = root.querySelector("[data-serial-field]");
      var dateField = root.querySelector("[data-date-field]");
      serialField.hidden = route !== "serial";
      dateField.hidden = route !== "manufacture-date";
      if (route !== "serial") form.querySelector('[data-field="serial"]').value = "";
      if (route !== "manufacture-date") form.querySelector('[data-field="manufacturingDate"]').value = "";
    }
    function update() { renderSummary(root); }

    form.querySelector('[data-field="identificationRoute"]').addEventListener("change", function () {
      updateRoute();
      update();
    });
    form.addEventListener("input", update);
    form.addEventListener("change", update);
    root.querySelectorAll("[data-next]").forEach(function (button) {
      button.addEventListener("click", function () {
        if (step < 2) {
          step += 1;
          renderSummary(root);
          setStep(root, step);
        }
      });
    });
    root.querySelectorAll("[data-back]").forEach(function (button) {
      button.addEventListener("click", function () {
        if (step > 0) {
          step -= 1;
          setStep(root, step);
        }
      });
    });
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var input = read(root);
      var result = assess(input);
      var serial = form.querySelector('[data-field="serial"]');
      if (serial) serial.value = "";
      renderResult(root, result);
    });
    resultContainer.addEventListener("click", function (event) {
      if (!event.target.closest("[data-review-answers]")) return;
      returnToAnswers(form, resultContainer, function () {
        step = 0;
        setStep(root, step);
      });
    });
    updateRoute();
    renderSummary(root);
    setStep(root, 0);
  }

  return {
    assess: assess,
    init: init,
    returnToAnswers: returnToAnswers,
    labels: { model: modelLabels, board: boardLabels, route: routeLabels }
  };
});
